import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { RUNTIME_CONFIG } from '@environments/runtime-config.token';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContractValidationService {
  private httpClient = inject(HttpClient);
  private url = `${inject(RUNTIME_CONFIG).apiUrl}/contracts`;

  verify(contractId: string): Observable<void> {
    return this.httpClient.post<void>(`${this.url}/${contractId}/verify`, {});
  }
}
